/**
 * @generated SignedSource<<4365ba3109073fcbc85f07c70e8857e5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addPricingRulePanel_PricingsListQuery$variables = Record<PropertyKey, never>;
export type addPricingRulePanel_PricingsListQuery$data = {
  readonly pricings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
        readonly printTypes: ReadonlyArray<{
          readonly printTypeID: number;
        } | null> | null;
      };
    }> | null;
  } | null;
};
export type addPricingRulePanel_PricingsListQuery = {
  response: addPricingRulePanel_PricingsListQuery$data;
  variables: addPricingRulePanel_PricingsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "PricingsConnection",
    "kind": "LinkedField",
    "name": "pricings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PricingsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PricingGroup",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricingName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pricingID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PricingPrintType",
                "kind": "LinkedField",
                "name": "printTypes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "printTypeID",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "pricings(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addPricingRulePanel_PricingsListQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addPricingRulePanel_PricingsListQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "6f73a059f5db77fc6435f634c357818d",
    "id": null,
    "metadata": {},
    "name": "addPricingRulePanel_PricingsListQuery",
    "operationKind": "query",
    "text": "query addPricingRulePanel_PricingsListQuery {\n  pricings(first: 200) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n        printTypes {\n          printTypeID\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f454a910d5be1574ad68d074fb074dea";

export default node;
